// extracted by mini-css-extract-plugin
export default {"page":"JJ","wrapper":"KJ","text":"LJ","icons":"MJ","icon":"NJ","icon_text":"OJ","carousel_wrapper":"PJ","slide":"QJ","image":"RJ","arrows":"SJ","prev":"TJ","modal_root":"UJ","x_mark":"VJ","modal":"WJ","images":"XJ","main_image":"YJ","name":"ZJ"};
    if(module.hot) {
      // 1713969934664
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  